import { motion } from "framer-motion";
import { EASE } from "../lib/site";

const parent = { hidden: {}, show: { transition: { staggerChildren: 0.12 } } };
const line = {
  hidden: { y: "105%", rotate: 2 },
  show: { y: "0%", rotate: 0, transition: { duration: 1.1, ease: EASE } },
};

// Masked line-by-line reveal; observer sits on the unclipped wrapper.
export const MaskLines = ({ lines, className = "", as = "h2", onLoad = false, delay = 0 }) => {
  const Tag = motion[as];
  const trigger = onLoad
    ? { initial: "hidden", animate: "show" }
    : { initial: "hidden", whileInView: "show", viewport: { once: true, amount: 0.1 } };
  return (
    <Tag className={className} variants={parent} transition={{ delayChildren: delay }} {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em]">
          <motion.span className="block will-change-transform" variants={line}>{l}</motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeUp = ({ children, className = "", delay = 0 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 36 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 1, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);
